<script setup lang="ts">
defineProps<{
  to?: string
}>()

const emit = defineEmits(['close'])
</script>

<template>
  <div class="py-6 px-4">
    <div
      class="absolute top-3 right-3 p-1 -m-1 rounded-full cursor-pointer hover:bg-gray-100 text-gray-400 hover:text-gray-500"
      @click="emit('close')"
    >
      <Icon i-heroicons-outline:x />
    </div>

    <div class="text-2xl mb-4 mr-6"> Ready to talk to an agent? </div>

    <ClickToCall
      :text="phone.formatted"
      :props="{ ctcLocation: 'back-button-modal' }"
      tty
    />

    <div class="text-lg my-4">
      <span class="font-semibold">Call now</span> to shop for a Medicare
      Advantage plan with added benefits
    </div>

    <div class="h-px bg-gray-200 mb-4"></div>

    <div class="text-lg text-center mb-2"> OR </div>

    <Button wide :to="to || '/ads'"> Shop Plans Online </Button>
  </div>
</template>
